<template>
  <b-card
    v-if="data"
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>報告</b-card-title>

      <!-- <b-dropdown
        variant="link"
        no-caret
        class="chart-dropdown"
        toggle-class="p-0"
        right
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="18"
            class="text-body cursor-pointer"
          />
        </template>
        <b-dropdown-item href="#">
          Last 28 Days
        </b-dropdown-item>
        <b-dropdown-item href="#">
          Last Month
        </b-dropdown-item>
        <b-dropdown-item href="#">
          Last Year
        </b-dropdown-item>
      </b-dropdown> -->
    </b-card-header>

    <b-card-body>
      <div
        v-for="transaction in data"
        :key="transaction.mode"
        class="transaction-item"
      >
        <div class="d-flex align-items-center">
          <b-avatar
            rounded
            size="42"
            :variant="transaction.avatarVariant"
          >
            <feather-icon
              size="18"
              :icon="transaction.avatar"
            />
          </b-avatar>
          <div class="ml-1">
            <div class="font-weight-bolder">
              {{ transaction.mode }}
            </div>
          </div>
        </div>
        <div
          class="font-weight-bolder text-primary"
        >
          {{ getCounts(transaction.payment) }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BAvatar, /* BDropdown, BDropdownItem, */
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BAvatar,
    /* BDropdown,
    BDropdownItem, */
  },
  data() {
    return {
      data: [
        {
          mode: '本日打卡',
          avatar: 'CheckCircleIcon',
          avatarVariant: 'light-primary',
          payment: 'dailyRecordCounts',
          deduction: true,
        },
        {
          mode: '本日新戶',
          avatar: 'UserCheckIcon',
          avatarVariant: 'light-primary',
          payment: 'dailyCustomerCounts',
          deduction: false,
        },
        {
          mode: '本月打卡',
          avatar: 'CheckCircleIcon',
          avatarVariant: 'light-warning',
          payment: 'monthlyRecordCounts',
          deduction: false,
        },
        {
          mode: '本月新戶',
          avatar: 'UserCheckIcon',
          avatarVariant: 'light-warning',
          payment: 'monthlyCustomerCounts',
          deduction: true,
        },
        {
          mode: '總打卡數',
          avatar: 'BookOpenIcon',
          avatarVariant: 'light-info',
          payment: 'totalRecords',
          deduction: false,
        },
        {
          mode: '總顧客數',
          avatar: 'UsersIcon',
          avatarVariant: 'light-info',
          payment: 'totalCustomers',
          deduction: false,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['user', 'dailyRecordCounts', 'dailyCustomerCounts', 'monthlyRecordCounts', 'monthlyCustomerCounts']),
  },
  mounted() {
    this.fetchDailyRecords()
  },
  methods: {
    fetchDailyRecords() {
      const today = this.$moment().format('YYYY-MM-DD 00:00:00')
      store.dispatch('getDailyRecordCounts', { uid: this.user.uid, date: today })
      store.dispatch('getDailyCustomerCounts', { uid: this.user.uid, date: today })
      store.dispatch('getMonthlyRecordCounts', { uid: this.user.uid, date: today })
      store.dispatch('getMonthlyCustomerCounts', { uid: this.user.uid, date: today })
    },
    getCounts(name) {
      if (name === 'totalCustomers') {
        return this.user.totalCustomers + this.dailyCustomerCounts
      }

      if (name === 'totalRecords') {
        return this.user.totalRecords + this.dailyRecordCounts
      }

      return this[name]
    },
  },
}
</script>
